import { GridValueGetterParams } from "@mui/x-data-grid";

/**
 * Convenience method for defining typesafe {GridColDef.valueGetter} function.
 * @param extract function to transform the row data (`dto`) into the desired value.
 */
export function from<D>(extract: (dto: D) => any) {
    return (params: GridValueGetterParams<any, D>) => extract(params.row);
}
